import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Link,
  Switch,
  Redirect,
  Route,
  useRouteMatch,
} from 'react-router-dom'

import { updateLoginStatus } from '../../../store/userSlice'
import { SubPageHeader } from '../../SubPageHeader'
import { Fdsnws } from './Fdsnws'


const PAGE_NAMES = {
  'fdsnws': 'FDSNWS',
}


export const OpenApi = () => {
  let match = useRouteMatch()
  const currentPath = window.location.pathname
  const currentPage = currentPath.substring(currentPath.lastIndexOf("/") + 1, currentPath.length)

  // Update login status
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(updateLoginStatus())
  }, [currentPage, dispatch])

  return (
    <div>
      <SubPageHeader 
        categoryUrl={match.path} categoryName={'OpenAPI'}
        pageName={PAGE_NAMES[currentPage] || ''} 
      />
      <Switch>
        <Route exact path={`${match.path}`}>
          <Redirect to={`${match.path}/fdsnws`} />
        </Route>
        <Route path={`${match.path}/fdsnws`}>
          {/* <Fdsnws /> */}
          <Redirect to="/data/web-services" />
        </Route>
        <Route>
          <div className="container">
            <div className="sub-container">
              <h3>페이지를 찾을 수 없습니다.</h3>
              <span><Link to="/">홈 화면으로 가기</Link></span>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  )
}